@if (isMatListItem() === false) {
  <mat-form-field appearance="outline" class="flex-1">
    <mat-label>{{label()}}</mat-label>
    <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="valuatorAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
    <button (click)="!isLoadingValuators && refreshValuators(); $event.stopPropagation();" matSuffix mat-icon-button color="primary">
      @if (isLoadingValuators) {
        <mat-spinner diameter="18"></mat-spinner>
      } @else {
        <mat-icon>refresh</mat-icon>
      }
    </button>
    <mat-autocomplete class="extendable-autocomplete" #valuatorAutoComplete="matAutocomplete" [displayWith]="displayWithValuator">
      @if (required() === false) {
        <mat-option [value]="null">
          <span translate="">None</span>
        </mat-option>
      }
      @for (valuator of valuatorsFiltered; track valuator) {
        <mat-option [value]="valuator">
          <span class="inline-autocomplete-option">
            <span>{{valuator.name}}</span>
            -
            <span class="gray">{{valuator.address.city}}</span>
          </span>
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
} @else {
  <mat-list-item>
    <label>{{label()}}</label>
    <mat-form-field floatLabel="never" class="inline-field">
      <div matSuffix="" class="flex items-center">
        @if (isLoadingValuators === true) {
          <mat-spinner diameter="14" class="mx2"></mat-spinner>
        }
      </div>
      <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="valuatorAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
      <mat-autocomplete class="inline-autocomplete extendable-autocomplete" #valuatorAutoComplete="matAutocomplete" [displayWith]="displayWithValuator">
        @if (required() === false) {
          <mat-option [value]="null">
            <span translate="">None</span>
          </mat-option>
        }
        @for (valuator of valuatorsFiltered; track valuator) {
          <mat-option [value]="valuator">
            <span class="inline-autocomplete-option">
              <span>{{valuator.name}}</span>-
              <span class="gray">{{valuator.address.city}}</span>
            </span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </mat-list-item>
}
